module.exports = __webpack_public_path__ + "img/certificate_36536663_00.a6e7c880.png";